
import Vue from "vue";

export default Vue.extend({
  name: "Leitungen",
  props: {
    value: {
      type: Number,
      default: 0
    },
    messst_nr: {
      type: String,
      required: true
    },
    messleitungen: {
      type: Array as () => any[],
      required: true
    }
  },
  data: function() {
    return {
      leitungs_nr: this.value
    };
  },
  watch: {
    leitungs_nr: function(v) {
      this.$emit("input", v);
    }
  }
});
